var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SoliResponsiveDialog", {
    ref: "dialog",
    attrs: {
      title: "Update Time Clock",
      subtitle: !!_vm.$page.props.currentTimeClock
        ? `Clocked-in on ${_vm.globalMomentFullDateAtTime(
            _vm.$page.props.currentTimeClock.starts_at
          )}`
        : `${_vm.currentTime}`,
      size: 400,
      "mobile-scroll": false,
      persistent: "",
    },
    on: {
      reset: function ($event) {
        return _vm.$emit("reset")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _vm.showOptions
              ? _c(
                  "v-container",
                  { staticClass: "pt-0" },
                  [
                    _c(
                      "v-form",
                      { ref: "form" },
                      [
                        _c("v-select", {
                          staticClass: "soli-round",
                          attrs: {
                            items: _vm.rateOptions,
                            "item-text": "role.name",
                            "item-value": "id",
                            "return-object": "",
                            dense: "",
                            outlined: "",
                            color: "primary",
                            label: "Working As",
                            "hide-details": "auto",
                            rules: [(v) => !!v || "Rate is required"],
                            loading: _vm.ratesLoading,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "item",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c("v-list-item-title", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              data.item.role.name
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("v-list-item-subtitle", [
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                `$${data.item.amount}/hour`
                                              )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3027367163
                          ),
                          model: {
                            value: _vm.selectRate,
                            callback: function ($$v) {
                              _vm.selectRate = $$v
                            },
                            expression: "selectRate",
                          },
                        }),
                        _vm._v(" "),
                        _vm.rateOptions?.length > 1
                          ? _c("v-switch", {
                              attrs: {
                                label: "Remember preference",
                                color: "primary",
                              },
                              model: {
                                value: _vm.preference,
                                callback: function ($$v) {
                                  _vm.preference = $$v
                                },
                                expression: "preference",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("v-divider"),
            _vm._v(" "),
            _c(
              "v-card-actions",
              { staticClass: "pb-0" },
              [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "soli-grey",
                    attrs: { text: "", rounded: "" },
                    on: {
                      click: function ($event) {
                        return _vm.reset()
                      },
                    },
                  },
                  [_vm._v("Nevermind")]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "accent",
                      text: "",
                      rounded: "",
                      loading: _vm.loading,
                      disabled: _vm.ratesLoading,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.toggleTimeClock()
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        !!_vm.$page.props.currentTimeClock
                          ? "Clock-out"
                          : "Clock-in"
                      )
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }